export const TOP_BAR_PERCENT = 15;
